<div class="uruk-list">
  <div class="uruk-list-status">
    <div [ngClass]="{'disabled':isMultipleActionsDisable}" *ngIf="displayMultipleActions" class="list-multi-actions">
      <div (click)="onUpdateItems.emit()" [nbTooltip]="'Update'| translate" class="list-action-button flex-centered">
        <div class="icon-text-container">
          <nb-icon [icon]="'sync-outline'" pack="eva"></nb-icon>
          <span>{{ 'Update'| translate }}</span>
        </div>
      </div>

      <div (click)="onResetItems.emit()" [nbTooltip]="'Set Default Settings'| translate" class="list-action-button flex-centered">
        <div class="icon-text-container">
          <nb-icon [icon]="'refresh-outline'" pack="eva"></nb-icon>
          <span>{{ 'Set Default Settings'| translate }}</span>
        </div>
      </div>

      <div (click)="onDeleteItems.emit()" [nbTooltip]="'Delete Devices'| translate" class="list-action-button flex-centered">
        <nb-icon [icon]="'trash-outline'" pack="eva"></nb-icon>
      </div>
    </div>
    <div *ngIf="displayVersionUpdateActions" class="list-multi-actions">
      <div (click)="onUploadNewVersion.emit()" [nbTooltip]="'Upload New Version'| translate" class="list-action-button flex-centered">
        <nb-icon [icon]="'upload-outline'" pack="eva"></nb-icon>
      </div>
      <nb-select
        class="columns-select"
        [multiple]="true"
        [(selected)]="selectedFields"
        (selectedChange)="onColumnsChange($event)"
        [nbTooltip]="'Select Columns' | translate"
        size="tiny"
      >
        <nb-option *ngFor="let col of columnMetadata; trackBy: trackByField"
                   [value]="col.field"
                   [disabled]="!canSelect(col)">
          {{ col.label | translate }}
        </nb-option>
      </nb-select>
    </div>

    <ng-container *ngFor="let status of statusMetadata">
      <span class="status-text {{status.class}}">{{ status.title | translate }}
        <span *ngIf="status.count >= 0 && displayCount" class="status-count">{{ status.count }}</span>
      <ng-container *ngIf="status.commaSeparated">,</ng-container></span>
    </ng-container>

    <div [ngClass]="{'search-bar-container-wrapper':displayFilter && displaySearch}">
      <div *ngIf="displaySearch" class="search-bar-container">
        <nb-form-field>
          <input type="text" [(ngModel)]="searchText" [placeholder]="searchPlaceholder | translate" (keyup.enter)="handleTextSearch()" nbInput>
          <button class="search-input-button" nbSuffix nbButton (click)="handleTextSearch()">
            <nb-icon [icon]="'search-outline'" pack="eva"></nb-icon>
          </button>
        </nb-form-field>

        <button *ngIf="displayFilter" nbButton class="filter-button" size="small" (click)="onFilterItems.emit()">
          <i class="fa fa-filter fa-xs"></i>
        </button>
      </div>
    </div>

  </div>
  <div class="uruk-list-view">
    <div class="list-view">
      <div class="list-header">
        <div *ngFor="let data of visibleColumns; trackBy: trackByField"
             [ngClass]="'col-' + data.columnWidth + (data.sortable ? ' sortable' : '')"
             class="list-header-column">
          <div *ngIf="displayCheckBox && data.field === 'id'" style="margin-left: 0; margin-right: 10px;">
            <input #selectAllCheckbox type="checkbox" (change)="handleSelectAll()">
          </div>
          {{ data.label | translate }}
          <div *ngIf="data.sortable" class="sort-icons">
            <nb-icon icon="caret-up" pack="fa" class="sort-icon"
                     [ngClass]="{'selected': currentSortField === data.field && sortDirection === 'asc'}"
                     (click)="sortAscending(data.field)">
            </nb-icon>
            <nb-icon icon="caret-down" pack="fa" class="sort-icon"
                     [ngClass]="{'selected': currentSortField === data.field && sortDirection === 'desc'}"
                     (click)="sortDescending(data.field)">
            </nb-icon>
          </div>
        </div>
        <div *ngIf="remainingColumnWidth > 0" [ngClass]="'col-' + remainingColumnWidth"></div>
      </div>

      <ng-container *ngIf="tableDataLoading; else checkList">
        <div class="list-loader-container">
          <div class="list-loader">
            <ng-lottie [options]="lottieOptions"></ng-lottie>
          </div>
        </div>
      </ng-container>

      <ng-template #checkList>
        <div *ngIf="list.length > 0; else noData" class="list-body">
          <div *ngFor="let item of list | metadata | async; let i = index"
               class="list-row"
               [ngClass]="{'ten-rows':pageSize === 10,'twenty-rows':pageSize === 20,'thirty-rows':pageSize === 30}">
            <div *ngFor="let data of visibleColumns; trackBy: trackByField"
                 [ngClass]="'col-' + data.columnWidth"
                 [title]="item[data.field + 'Tooltip'] || ''">
              <div class="vertical-container">
                <div *ngIf="displayCheckBox && data.field === 'id'">
                  <input type="checkbox" class="list-actions actions-check-input" (change)="onSelectItem.emit(item['id'])">
                </div>
                <ng-container *ngIf="item[data.field]?.length > 20; else noTooltip">
                  <span
                    [nbTooltip]="item[data.field]?.length > 20 ? item[data.field] : null"
                    [nbTooltipPlacement]="'left'"
                    [innerHTML]="item[data.field] | translate">
                  </span>
                </ng-container>
                <ng-template #noTooltip>
                  <span [innerHTML]="item[data.field] | translate"></span>
                </ng-template>
              </div>
            </div>
            <!-- GAP -->
            <div *ngIf="remainingColumnWidth > 0" [ngClass]="'col-' + remainingColumnWidth"></div>
            <div class="col-1 list-actions">
              <div (click)="onActionItem.emit(item)" *ngIf="displayActionButton"
                   class="list-action-button flex-centered">
                <i [ngClass]="actionIconClass"></i>
              </div>

              <div (click)="onEditItem.emit(list[i])" *ngIf="displayEditButton"
                   class="list-action-button flex-centered">
                <i [ngClass]="editIconClass"></i>
              </div>

              <div (click)="onDeleteItem.emit(item.id)" *ngIf="deleteButtonVisibilityForItem[i]"
                   class="list-action-button flex-centered">
                <i [ngClass]="deleteIconClass"></i>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #noData>
        <div class="list-body">
          <div class="list-row no-data-row"
               [ngClass]="{'ten-rows':pageSize === 10,'twenty-rows':pageSize === 20,'thirty-rows':pageSize === 30}">
            {{ 'noDataAvailable' | translate }}
          </div>
        </div>
      </ng-template>

      <div class="list-footer">
        <pagination #pagination *ngIf="statusMetadata.length" [total]="statusMetadata[0].count"
                    (paginate)="paginate($event)"
                    [type]="type">
        </pagination>
      </div>
    </div>
  </div>
</div>
